module.exports = __webpack_public_path__ + "img/small-default-billboard.051fa18d.png";